<template>
<span>
<iframe v-for="l in len" :src=src />
</span>
</template>

<script>

    export default {
        data : function(){
            return {
                len : []
            }
        },
        props: {
            src : ""
        },
        created(){
            this.len.push(1)
        },
        watch: { 
            src: function() {
                this.len = []
                this.$nextTick(function(){
                    
                    this.len.push(1)
                    
                })
            }
        },
    }
    

</script>

<style>
</style>